import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDraftDialogComments } from "store/bailiff/draft/dialog/draft_dialog.action";
import { draftDialogEditedCommentsSelector } from "store/bailiff/draft/dialog_edited/dialog_edited.selector";
//
//component
//redux
//selector
//actions
export const TriggerComment = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const comments = useSelector(draftDialogEditedCommentsSelector);
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (comments) {
      dispatch(setDraftDialogComments(comments));
    }
  }, [dispatch, comments]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerComment;
